import { render, staticRenderFns } from "./SocialsCreate.vue?vue&type=template&id=d3fdad78&lang=pug"
import script from "./SocialsCreate.vue?vue&type=script&lang=js"
export * from "./SocialsCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports